let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9K0JL")).then(() => parcelRequire('lToDU'));